import {Component, Input, OnInit, Output} from '@angular/core';
import {ReferralWithNavigationProperties} from '@models/data/referral/ReferralWithNavigationProperties';
import {IconsDefinitionHelper} from '@shared/common/definition-helper';
import { EdFitMedProfileSmallComponent } from '../../fitmedprofiles/ed-fit-med-profile-small/ed-fit-med-profile-small.component';

@Component({
    selector: 'app-referral-list-item',
    templateUrl: './referral-list-item.component.html',
    styleUrls: ['./referral-list-item.component.scss'],
    standalone: true,
    imports: [EdFitMedProfileSmallComponent]
})
export class ReferralListItemComponent extends IconsDefinitionHelper implements OnInit {
  @Input() referral: ReferralWithNavigationProperties = null;
  @Input() clickable = false;

  constructor() {
    super();
  }

  ngOnInit(): void {
  }
}
